import _classCallCheck from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _inherits from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _get from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get.js";
import _getPrototypeOf from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _toConsumableArray from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _createForOfIteratorHelper from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _regeneratorRuntime from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator/index.js";

function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }

  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}

import { getFirstItem as $iLnZt$getFirstItem, getLastItem as $iLnZt$getLastItem } from "@react-stately/collections";
import { GridCollection as $iLnZt$GridCollection } from "@react-stately/grid";
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

var $788781baa30117fa$var$ROW_HEADER_COLUMN_KEY = 'row-header-column-' + Math.random().toString(36).slice(2);
var $788781baa30117fa$var$ROW_HEADER_COLUMN_KEY_DRAG = 'row-header-column-' + Math.random().toString(36).slice(2);

while ($788781baa30117fa$var$ROW_HEADER_COLUMN_KEY === $788781baa30117fa$var$ROW_HEADER_COLUMN_KEY_DRAG) $788781baa30117fa$var$ROW_HEADER_COLUMN_KEY_DRAG = 'row-header-column-' + Math.random().toString(36).slice(2);

function $788781baa30117fa$export$7c127db850d4e81e(keyMap, columnNodes) {
  if (columnNodes.length === 0) return [];
  var columns = [];
  var seen = new Map();

  var _iterator = _createForOfIteratorHelper(columnNodes),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _column = _step.value;
      var parentKey = _column.parentKey;
      var col = [_column];

      while (parentKey) {
        var parent = keyMap.get(parentKey);
        if (!parent) break; // If we've already seen this parent, than it is shared
        // with a previous column. If the current column is taller
        // than the previous column, than we need to shift the parent
        // in the previous column so it's level with the current column.

        if (seen.has(parent)) {
          var _parent;

          var _colSpan;

          (_colSpan = (_parent = parent).colSpan) !== null && _colSpan !== void 0 ? _colSpan : _parent.colSpan = 0;
          parent.colSpan++;
          parent.colspan = parent.colSpan;

          var _seen$get2 = seen.get(parent),
              _column2 = _seen$get2.column,
              index = _seen$get2.index;

          if (index > col.length) break;

          for (var _i4 = index; _i4 < col.length; _i4++) _column2.splice(_i4, 0, null); // Adjust shifted indices


          for (var _i6 = col.length; _i6 < _column2.length; _i6++) // eslint-disable-next-line max-depth
          if (_column2[_i6] && seen.has(_column2[_i6])) seen.get(_column2[_i6]).index = _i6;
        } else {
          parent.colSpan = 1;
          parent.colspan = 1;
          col.push(parent);
          seen.set(parent, {
            column: col,
            index: col.length - 1
          });
        }

        parentKey = parent.parentKey;
      }

      columns.push(col);
      _column.index = columns.length - 1;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  var maxLength = Math.max.apply(Math, _toConsumableArray(columns.map(function (c) {
    return c.length;
  })));
  var headerRows = Array(maxLength).fill(0).map(function () {
    return [];
  }); // Convert columns into rows.

  var colIndex = 0;

  for (var _i = 0, _columns = columns; _i < _columns.length; _i++) {
    var column = _columns[_i];

    var _i2 = maxLength - 1;

    var _iterator2 = _createForOfIteratorHelper(column),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var item = _step2.value;

        if (item) {
          // Fill the space up until the current column with a placeholder
          var row = headerRows[_i2];
          var rowLength = row.reduce(function (p, c) {
            var _c_colSpan;

            return p + ((_c_colSpan = c.colSpan) !== null && _c_colSpan !== void 0 ? _c_colSpan : 1);
          }, 0);

          if (rowLength < colIndex) {
            var placeholder = {
              type: 'placeholder',
              key: 'placeholder-' + item.key,
              colspan: colIndex - rowLength,
              colSpan: colIndex - rowLength,
              index: rowLength,
              value: null,
              rendered: null,
              level: _i2,
              hasChildNodes: false,
              childNodes: [],
              textValue: ''
            }; // eslint-disable-next-line max-depth

            if (row.length > 0) {
              row[row.length - 1].nextKey = placeholder.key;
              placeholder.prevKey = row[row.length - 1].key;
            }

            row.push(placeholder);
          }

          if (row.length > 0) {
            row[row.length - 1].nextKey = item.key;
            item.prevKey = row[row.length - 1].key;
          }

          item.level = _i2;
          item.colIndex = colIndex;
          row.push(item);
        }

        _i2--;
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }

    colIndex++;
  } // Add placeholders at the end of each row that is shorter than the maximum


  var i = 0;

  var _iterator3 = _createForOfIteratorHelper(headerRows),
      _step3;

  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var _row = _step3.value;

      var _rowLength = _row.reduce(function (p, c) {
        var _c_colSpan;

        return p + ((_c_colSpan = c.colSpan) !== null && _c_colSpan !== void 0 ? _c_colSpan : 1);
      }, 0);

      if (_rowLength < columnNodes.length) {
        var _placeholder = {
          type: 'placeholder',
          key: 'placeholder-' + _row[_row.length - 1].key,
          colSpan: columnNodes.length - _rowLength,
          colspan: columnNodes.length - _rowLength,
          index: _rowLength,
          value: null,
          rendered: null,
          level: i,
          hasChildNodes: false,
          childNodes: [],
          textValue: '',
          prevKey: _row[_row.length - 1].key
        };

        _row.push(_placeholder);
      }

      i++;
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }

  return headerRows.map(function (childNodes, index) {
    var row = {
      type: 'headerrow',
      key: 'headerrow-' + index,
      index: index,
      value: null,
      rendered: null,
      level: 0,
      hasChildNodes: true,
      childNodes: childNodes,
      textValue: ''
    };
    return row;
  });
}

var $788781baa30117fa$export$596e1b2e2cf93690 = /*#__PURE__*/function (_ref, _Symbol$iterator) {
  function $788781baa30117fa$export$596e1b2e2cf93690(nodes, prev, opts) {
    var _this2;

    _classCallCheck(this, $788781baa30117fa$export$596e1b2e2cf93690);

    var rowHeaderColumnKeys = new Set();
    var body = null;
    var columns = []; // Add cell for selection checkboxes if needed.

    if (opts === null || opts === void 0 ? void 0 : opts.showSelectionCheckboxes) {
      var rowHeaderColumn = {
        type: 'column',
        key: $788781baa30117fa$var$ROW_HEADER_COLUMN_KEY,
        value: null,
        textValue: '',
        level: 0,
        index: (opts === null || opts === void 0 ? void 0 : opts.showDragButtons) ? 1 : 0,
        hasChildNodes: false,
        rendered: null,
        childNodes: [],
        props: {
          isSelectionCell: true
        }
      };
      columns.unshift(rowHeaderColumn);
    } // Add cell for drag buttons if needed.


    if (opts === null || opts === void 0 ? void 0 : opts.showDragButtons) {
      var _rowHeaderColumn = {
        type: 'column',
        key: $788781baa30117fa$var$ROW_HEADER_COLUMN_KEY_DRAG,
        value: null,
        textValue: '',
        level: 0,
        index: 0,
        hasChildNodes: false,
        rendered: null,
        childNodes: [],
        props: {
          isDragButtonCell: true
        }
      };
      columns.unshift(_rowHeaderColumn);
    }

    var rows = [];
    var columnKeyMap = new Map();

    var _visit = function visit(node) {
      switch (node.type) {
        case 'body':
          body = node;
          break;

        case 'column':
          columnKeyMap.set(node.key, node);

          if (!node.hasChildNodes) {
            columns.push(node);
            if (node.props.isRowHeader) rowHeaderColumnKeys.add(node.key);
          }

          break;

        case 'item':
          rows.push(node);
          return;
        // do not go into childNodes
      }

      var _iterator4 = _createForOfIteratorHelper(node.childNodes),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var child = _step4.value;

          _visit(child);
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
    };

    var _iterator5 = _createForOfIteratorHelper(nodes),
        _step5;

    try {
      for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
        var node = _step5.value;

        _visit(node);
      }
    } catch (err) {
      _iterator5.e(err);
    } finally {
      _iterator5.f();
    }

    var headerRows = $788781baa30117fa$export$7c127db850d4e81e(columnKeyMap, columns);
    headerRows.forEach(function (row, i) {
      return rows.splice(i, 0, row);
    });
    _this2 = _callSuper(this, $788781baa30117fa$export$596e1b2e2cf93690, [{
      columnCount: columns.length,
      items: rows,
      visitNode: function visitNode(node) {
        node.column = columns[node.index];
        return node;
      }
    }]), _this2._size = 0;
    _this2.columns = columns;
    _this2.rowHeaderColumnKeys = rowHeaderColumnKeys;
    _this2.body = body;
    _this2.headerRows = headerRows;
    _this2._size = _toConsumableArray(body.childNodes).length; // Default row header column to the first one.

    if (_this2.rowHeaderColumnKeys.size === 0) {
      var col = _this2.columns.find(function (column) {
        var _column_props, _column_props1;

        return !((_column_props = column.props) === null || _column_props === void 0 ? void 0 : _column_props.isDragButtonCell) && !((_column_props1 = column.props) === null || _column_props1 === void 0 ? void 0 : _column_props1.isSelectionCell);
      });

      if (col) _this2.rowHeaderColumnKeys.add(col.key);
    }

    return _this2;
  }

  _inherits($788781baa30117fa$export$596e1b2e2cf93690, _ref);

  return _createClass($788781baa30117fa$export$596e1b2e2cf93690, [{
    key: _Symbol$iterator,
    value: /*#__PURE__*/_regeneratorRuntime.mark(function value() {
      return _regeneratorRuntime.wrap(function value$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            return _context.delegateYield(this.body.childNodes, "t0", 1);

          case 1:
          case "end":
            return _context.stop();
        }
      }, value, this);
    })
  }, {
    key: "size",
    get: function get() {
      return this._size;
    }
  }, {
    key: "getKeys",
    value: function getKeys() {
      return this.keyMap.keys();
    }
  }, {
    key: "getKeyBefore",
    value: function getKeyBefore(key) {
      var node = this.keyMap.get(key);

      var _node_prevKey;

      return (_node_prevKey = node === null || node === void 0 ? void 0 : node.prevKey) !== null && _node_prevKey !== void 0 ? _node_prevKey : null;
    }
  }, {
    key: "getKeyAfter",
    value: function getKeyAfter(key) {
      var node = this.keyMap.get(key);

      var _node_nextKey;

      return (_node_nextKey = node === null || node === void 0 ? void 0 : node.nextKey) !== null && _node_nextKey !== void 0 ? _node_nextKey : null;
    }
  }, {
    key: "getFirstKey",
    value: function getFirstKey() {
      var _getFirstItem;

      var _getFirstItem_key;

      return (_getFirstItem_key = (_getFirstItem = (0, $iLnZt$getFirstItem)(this.body.childNodes)) === null || _getFirstItem === void 0 ? void 0 : _getFirstItem.key) !== null && _getFirstItem_key !== void 0 ? _getFirstItem_key : null;
    }
  }, {
    key: "getLastKey",
    value: function getLastKey() {
      var _getLastItem;

      var _getLastItem_key;

      return (_getLastItem_key = (_getLastItem = (0, $iLnZt$getLastItem)(this.body.childNodes)) === null || _getLastItem === void 0 ? void 0 : _getLastItem.key) !== null && _getLastItem_key !== void 0 ? _getLastItem_key : null;
    }
  }, {
    key: "getItem",
    value: function getItem(key) {
      var _this_keyMap_get;

      return (_this_keyMap_get = this.keyMap.get(key)) !== null && _this_keyMap_get !== void 0 ? _this_keyMap_get : null;
    }
  }, {
    key: "at",
    value: function at(idx) {
      var keys = _toConsumableArray(this.getKeys());

      return this.getItem(keys[idx]);
    }
  }, {
    key: "getChildren",
    value: function getChildren(key) {
      if (key === this.body.key) return this.body.childNodes;
      return _get(_getPrototypeOf($788781baa30117fa$export$596e1b2e2cf93690.prototype), "getChildren", this).call(this, key);
    }
  }, {
    key: "getTextValue",
    value: function getTextValue(key) {
      var row = this.getItem(key);
      if (!row) return ''; // If the row has a textValue, use that.

      if (row.textValue) return row.textValue; // Otherwise combine the text of each of the row header columns.

      var rowHeaderColumnKeys = this.rowHeaderColumnKeys;

      if (rowHeaderColumnKeys) {
        var text = [];

        var _iterator6 = _createForOfIteratorHelper(row.childNodes),
            _step6;

        try {
          for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
            var cell = _step6.value;
            var column = this.columns[cell.index];
            if (rowHeaderColumnKeys.has(column.key) && cell.textValue) text.push(cell.textValue);
            if (text.length === rowHeaderColumnKeys.size) break;
          }
        } catch (err) {
          _iterator6.e(err);
        } finally {
          _iterator6.f();
        }

        return text.join(' ');
      }

      return '';
    }
  }]);
}((0, $iLnZt$GridCollection), Symbol.iterator);

export { $788781baa30117fa$export$7c127db850d4e81e as buildHeaderRows, $788781baa30117fa$export$596e1b2e2cf93690 as TableCollection };